import * as glb from "../globals";
import Axios from "./axios";
import * as utl from "../utils/utils";
import Dict from '../messages';
import { _ as maskPassword } from '../utils/utils';
import { getSelectableUsers } from '../utils/userLookup';
import { applyGlobalKullaniciLkp } from '../utils/kullaniciLkp';
import { applyGlobalSabitLkp } from '../utils/sabitLkp';
import { applyGlobalIslemsablonLkp } from '../utils/islemsablonLkp';
import { persistLookupCache, readLookupCache } from '../utils/lookupStorage';
import { sortSabitLookup } from '../utils/sabitSort';
import { clearLoginLockState, writeLoginLockState } from '../utils/loginLockState';
import { grantMissingScreenDelete } from '../utils/ownRecordDelete';

export async function signIn(userName, userPassword) {
  try {
    let boolres = false;
    let strres = '';
    // Mask password so it does not appear in Network tab / plain form
    const maskedPassword = (userPassword && typeof userPassword === 'string' && userPassword.length >= 20)
      ? userPassword
      : maskPassword(userPassword || '');
    const res = await Axios.get(
      `${process.env.REACT_APP_BACKEND_SERVER}authusr?username=${encodeURIComponent(userName)}&userpassword=${encodeURIComponent(maskedPassword)}`
    );
    if (res.data && res.data.token) {
      clearLoginLockState(userName);
      // JWT token'ı kaydet
      localStorage.setItem('jwt_token', res.data.token);
      Axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token;
    }
    const loginUser = res.data?.user;
    const loginAdi = loginUser?.KUL_ADI ?? loginUser?.kul_adi;
    if (loginUser && loginAdi && String(loginAdi).length > 0) {
      if (!loginUser.KUL_ADI && loginUser.kul_adi) loginUser.KUL_ADI = loginUser.kul_adi;
      // Tüm lookup ve kullanıcı verilerini localStorage'a kaydet
      localStorage.setItem('KULLANICI', JSON.stringify(loginUser));
      localStorage.setItem('HAKLkp', JSON.stringify(res.data.right));
      const screenRights = grantMissingScreenDelete(res.data.screen);
      localStorage.setItem('EKRANLkp', JSON.stringify(screenRights));
      localStorage.setItem('ROLLkp', JSON.stringify(res.data.role));
      localStorage.setItem('FIRMALkp', JSON.stringify(res.data.corp));
      // Belleğe de yükle
      glb.default.KULLANICI = loginUser;
      glb.default.HAKLkp = res.data.right;
      glb.default.EKRANLkp = screenRights;
      glb.default.ROLLkp = res.data.role;
      glb.default.FIRMALkp = res.data.corp;
      boolres = true;
      strres = '';
      // Diğer lookup'lar paralel alınabilir
      Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}doalls/lkp?ptype=user`).then(res => {
        applyGlobalKullaniciLkp(res.data);
      }).catch(err => { console.log(err); });
      Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}doalls/lkp?ptype=ULKE`).then(res => { glb.default.ULKELkp = res.data; persistLookupCache('ULKELkp', res.data); }).catch(err => { console.log(err); });
      Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}doalls/lkp?ptype=IL`).then(res => { glb.default.ILLkp = res.data; persistLookupCache('ILLkp', res.data); }).catch(err => { console.log(err); });
      Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}doalls/lkp?ptype=ILCE`).then(res => { glb.default.ILCELkp = res.data; persistLookupCache('ILCELkp', res.data); }).catch(err => { console.log(err); });
      Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}doalls/lkp?ptype=MESLEK`).then(res => { glb.default.meslekLkp = res.data || []; persistLookupCache('meslekLkp', glb.default.meslekLkp); }).catch(err => { console.log(err); });
      Promise.all([
        Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}SABIT/sabitlist`),
        Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}SABIT/sabitgrup`),
      ]).then(([sabitRes, grupRes]) => {
        applyGlobalSabitLkp(sabitRes?.data, grupRes?.data);
      }).catch(err => { console.log(err); });
      Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_SATIS/islemsablon`).then(res => {
        applyGlobalIslemsablonLkp(res?.data);
      }).catch(err => { console.log(err); });
    } else {
      glb.default.KULLANICI = null;
      boolres = false;
      strres = Dict.get('Authentication failed');
    }
    return {
      isOk: boolres,
      data: glb.default.KULLANICI,
      message: strres
    };
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message;
    const isLockedResponse = /1 dakika/.test(String(msg || '')) || Number(err?.response?.status) === 423;
    if (isLockedResponse) {
      const nextLockUntil = Date.now() + 60 * 1000;
      writeLoginLockState(userName, {
        count: 3,
        lockUntil: nextLockUntil,
        lastFailedAt: Date.now(),
      });
      return {
        isOk: false,
        message: '3 kez hatalı giriş yaptınız. Lütfen 1 dakika sonra tekrar deneyin.',
        lockedUntil: nextLockUntil,
      };
    }
    return {
      isOk: false,
      message: msg || Dict.get('Doğrulama başarısız')
    };
  }
}

export async function getUser() {
  try {
    // Önce localStorage'dan yükle
    const user = localStorage.getItem('KULLANICI');
    const token = localStorage.getItem('jwt_token');
    if (user && token) {
      glb.default.KULLANICI = JSON.parse(user);
      const HAKLkp = localStorage.getItem('HAKLkp');
      if (HAKLkp) glb.default.HAKLkp = JSON.parse(HAKLkp);
      const EKRANLkp = localStorage.getItem('EKRANLkp');
      if (EKRANLkp) {
        const screenRights = grantMissingScreenDelete(JSON.parse(EKRANLkp));
        glb.default.EKRANLkp = screenRights;
        localStorage.setItem('EKRANLkp', JSON.stringify(screenRights));
      }
      const ROLLkp = localStorage.getItem('ROLLkp');
      if (ROLLkp) glb.default.ROLLkp = JSON.parse(ROLLkp);
      const FIRMALkp = localStorage.getItem('FIRMALkp');
      if (FIRMALkp) glb.default.FIRMALkp = JSON.parse(FIRMALkp);
      const kullaniciLkpCached = readLookupCache('KULLANICILkp');
      if (kullaniciLkpCached) glb.default.KULLANICILkp = kullaniciLkpCached;
      const kullaniciSecimCached = readLookupCache('KULLANICISECIMLkp');
      if (kullaniciSecimCached) glb.default.KULLANICISECIMLkp = kullaniciSecimCached;
      else glb.default.KULLANICISECIMLkp = getSelectableUsers(glb.default.KULLANICILkp);
      const ulkeCached = readLookupCache('ULKELkp');
      if (ulkeCached) glb.default.ULKELkp = ulkeCached;
      const ilCached = readLookupCache('ILLkp');
      if (ilCached) glb.default.ILLkp = ilCached;
      const ilceCached = readLookupCache('ILCELkp');
      if (ilceCached) glb.default.ILCELkp = ilceCached;
      const meslekCached = readLookupCache('meslekLkp');
      if (meslekCached) glb.default.meslekLkp = meslekCached;
      const sabitCached = readLookupCache('sabitLkp');
      if (sabitCached) glb.default.sabitLkp = sortSabitLookup(sabitCached);
      const sabitgrupCached = readLookupCache('sabitgrupLkp');
      if (sabitgrupCached) glb.default.sabitgrupLkp = sabitgrupCached;
      const islemsablonCached = readLookupCache('islemsablonLkp');
      if (islemsablonCached) applyGlobalIslemsablonLkp(islemsablonCached);
      Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      return { isOk: true, data: glb.default.KULLANICI };
    }
    // Eğer localStorage'da yoksa veya token yoksa backend'den çek
    if (!token) return { isOk: false };
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}authusr/me`);
    if (res.data && res.data.user) {
      // Backend'den gelen güncel kullanıcıyı da localStorage ve belleğe yaz
      localStorage.setItem('KULLANICI', JSON.stringify(res.data.user));
      glb.default.KULLANICI = res.data.user;
      return { isOk: true, data: res.data.user };
    }
    return { isOk: false };
  } catch (err) {
    return { isOk: false };
  }
}

export async function createAccount(email, password) {
  return {
    isOk: true
  };
}

export async function changePassword(email, recoveryCode) {
  return {
    isOk: true
  };
}

export async function resetPassword(email) {
  try {
    const res = await Axios.post(`${process.env.REACT_APP_BACKEND_SERVER}authusr/reset-password`, { email });
    if (res.status === 200) {
      return { isOk: true };
    } else {
      return { isOk: false, message: res.data?.message || 'Reset failed' };
    }
  } catch (err) {
    return { isOk: false, message: err?.response?.data?.message || err.message };
  }
}
